import { render, staticRenderFns } from "./EditQuiz.vue?vue&type=template&id=49aab202&"
import script from "./EditQuiz.vue?vue&type=script&lang=js&"
export * from "./EditQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EditQuiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports